import React, { useContext, useEffect, useState } from "react";
import { useSiteConfig } from "../context/SiteConfigContext";
import { Link, NavLink, useNavigate } from "react-router-dom";
import CartCanvas from "../pages/canvas/CartCanvas";
import LoginCanvas from "../pages/canvas/LoginCanvas";
import RegisterCanvas from "../pages/canvas/RegisterCanvas";
import Auth from "../utils/AuthUtils";
import { useCart } from "../context/CartContext";
import SearchCanvas from "../pages/canvas/SearchCanvas";
import {
  ArrowRight,
  Home,
  Menu,
  Search,
  ShoppingBag,
  User,
  X,
} from "lucide-react";
import productAPI from "../api/productApi";
// import { FaDisease, FaNotesMedical } from "react-icons/fa";
import { FaDisease, FaChevronDown, FaNotesMedical } from "react-icons/fa";
import { CategoryContext } from "../context/CategoryContext";

function Header() {
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [searchText, setSearchText] = useState("");

  const [open, setOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const { cartItems } = useCart();
  const { config } = useSiteConfig();
  const isLoggedIn = Auth.getToken();
  const navigate = useNavigate();
  const { categories } = useContext(CategoryContext);

  if (!config) return null;

  const handleModalShow = () => {
    setShowSearchModal(true);
  };

  const closeMenuAndNavigate = (path) => {
    const closeBtn = document.querySelector('[data-bs-dismiss="offcanvas"]');
    if (closeBtn) closeBtn.click();
    navigate(path);
  };

  return (
    <>
      <div className="announcement-bar">
        <div className="marquee-wrapper">
          <div className="marquee-content">
            <span>निर्मित उत्पाद</span>
            <span className="separator">•</span>
            <span>आयुर्वेदिक निर्माण उत्पाद</span>
            <span className="separator">•</span>
            <span>प्राकृतिक उत्पाद</span>
            <span>निर्मित उत्पाद</span>
            <span className="separator">•</span>
            <span>आयुर्वेदिक निर्माण उत्पाद</span>
            <span className="separator">•</span>
            <span>प्राकृतिक उत्पाद</span>
          </div>
        </div>
      </div>

      {/* 2. Main Header (Top) */}
      <header className="skin-header sticky-top">
        <div className="container py-2 mb-2">
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ height: "var(--header-height)" }}
          >
            <div className=" ">
              <NavLink
                to="/"
                className="brand-text d-flex align-items-center gap-2"
              >
                <img src={config?.logo} alt="logo" className="logo-img" />
              </NavLink>
            </div>
            {/* LEFT: Mobile Toggle + Desktop Nav */}
            <div className="d-flex align-items-center">
              <button
                className="icon-btn d-lg-none me-2"
                data-bs-toggle="offcanvas"
                data-bs-target="#mobileMenu"
              >
                <Menu size={22} />
              </button>

              <nav className="d-none d-lg-flex">
                <NavLink
                  to="/shop"
                  className="nav-link-custom text-decoration-none"
                >
                  Medicine
                </NavLink>
                <Link
                  to="/about-us"
                  className="nav-link-custom text-decoration-none"
                >
                  About
                </Link>
                <Link
                  to="/blog"
                  className="nav-link-custom text-decoration-none"
                >
                  Blog
                </Link>
                <Link
                  to="/contact-us"
                  className="nav-link-custom text-decoration-none"
                >
                  Contact
                </Link>
                <div>
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      setOpen((prev) => !prev);
                    }}
                    to=""
                    className="ax-disease-btn nav-link-custom text-decoration-none"
                  >
                    Diseases
                    <FaChevronDown className="ms-2 ax-arrow" />
                  </Link>

                  {/* Dropdown */}
                  {open && (
                    <>
                      <div className="ax-dropdown-menu show p-3">
                        <Link to="categories" className="ax-dropdown-item">
                          All Diseases <ArrowRight size={16} />
                        </Link>
                        {categories.map((cat) => (
                          <Link
                            key={cat._id}
                            to={`/categories/${cat.slugPath}`}
                            className="ax-dropdown-item"
                          >
                            {cat.name}
                            <ArrowRight size={16} />
                          </Link>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              </nav>
            </div>

            {/* CENTER: Brand Logo with Breathing Animation */}

            {/* RIGHT: DESKTOP ONLY Actions */}
            <div className="d-none d-lg-flex align-items-center gap-3">
              <span
                className="icon-btn"
                data-bs-toggle="modal"
                data-bs-target="#searchModal"
              >
                <Search size={18} />
              </span>

              <Link
                to={isLoggedIn ? "/users/dashboard" : "/users/login"}
                className="icon-btn"
              >
                <User size={18} />
              </Link>

              <button
                className="icon-btn position-relative"
                data-bs-toggle="offcanvas"
                data-bs-target="#cartDrawer"
              >
                <ShoppingBag size={18} />
                {cartItems.length > 0 && (
                  <span className="badge-count pulse-badge">
                    {cartItems.length}
                  </span>
                )}
                {/* {cartItems.length} */}
              </button>
            </div>

            {/* <div className="d-lg-none" style={{width: '24px'}}></div> */}
          </div>
        </div>
      </header>

      {/*  3. UNIQUE: "FLOATING ISLAND" BOTTOM NAV (Mobile Only)  */}
      <div className="island-nav-container d-lg-none">
        <div className="island-nav glass-panel">
          <NavLink
            to="/"
            className={({ isActive }) =>
              `island-item ${isActive ? "active" : ""}`
            }
          >
            <div className="icon-wrapper">
              <Home />
            </div>
          </NavLink>

          <span
            data-bs-toggle="modal"
            data-bs-target="#searchModal"
            className="island-item"
          >
            <div className="icon-wrapper">
              <Search />
            </div>
          </span>

          <Link
            to={isLoggedIn ? "/users/dashboard" : "/users/login"}
            style={{
              textDecoration: "none",
              color: "rgba(255, 255, 255, 0.5)",
            }}
            className={({ isActive }) =>
              `island-item  ${isActive ? "active" : ""}`
            }
          >
            <div className="icon-wrapper">
              <User />
            </div>
          </Link>

          <button
            className="island-item position-relative"
            data-bs-toggle="offcanvas"
            data-bs-target="#cartDrawer"
          >
            <div className="icon-wrapper">
              <ShoppingBag />
              {cartItems.length > 0 && <span className="island-badge"></span>}
            </div>
          </button>
        </div>
      </div>

      {/* --- SEARCH OVERLAY --- */}
      <div
        className="modal fade popup-search"
        id="searchModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-hidden="true"
      >
        <SearchCanvas isOpen={showSearchModal} />
      </div>

      <div className="offcanvas offcanvas-end" id="cartDrawer" tabIndex="-1">
        <CartCanvas />
      </div>

      {/* --- SIDE MENUS (Unchanged functionality, styled below) --- */}
      <div className="offcanvas offcanvas-start" id="mobileMenu" tabIndex="-1">
        <div className="offcanvas-header border-bottom">
          <h5 className="m-0 drawer-title">MENU</h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
          ></button>
        </div>
        <div className="offcanvas-body p-4">
          <ul className="list-unstyled d-flex flex-column gap-3">
            <li>
              <button
                className="mobile-link-btn w-100 text-start"
                onClick={() => closeMenuAndNavigate("/")}
              >
                Home
              </button>
            </li>
            <li>
              <button
                className="mobile-link-btn w-100 text-start"
                onClick={() => closeMenuAndNavigate("shop")}
              >
                Medicine
              </button>
            </li>
            <li>
              <button
                className="mobile-link-btn w-100 text-start"
                onClick={() => closeMenuAndNavigate("about-us")}
              >
                About
              </button>
            </li>
            <li>
              <button
                className="mobile-link-btn w-100 text-start"
                onClick={() => closeMenuAndNavigate("contact-us")}
              >
                Contact
              </button>
            </li>
            <div
              className=" pt-1 dropdown"
              onMouseEnter={() => setOpen(true)}
              onMouseLeave={() => setOpen(false)}
            >
              <Link
                to=""
                className="mobile-link-btn w-100 text-start "
                onClick={() => closeMenuAndNavigate("contact-us")}
              >
                Diseases
                <FaChevronDown className="ms-2 ax-arrow" />
              </Link>
              {/* Dropdown */}
              {open && (
                <div className="dropdown-menu show p-3">
                  <Link to="categories" className="custom-text-header">
                    All Diseases <ArrowRight size={16} />
                  </Link>

                  {categories.map((cat) => (
                    <Link
                      key={cat._id}
                      to={`/categories/${cat.slugPath}`}
                      className="custom-text-header"
                    >
                      {cat.name}
                      <ArrowRight size={16} />
                    </Link>
                  ))}
                </div>
              )}
            </div>
          </ul>
        </div>
      </div>
    </>
  );
}

export default Header;
